/*
 *
 * Hedera Stablecoin SDK
 *
 * Copyright (C) 2023 Hedera Hashgraph, LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OptionalField } from '../../../core/decorator/OptionalDecorator.js';
import { SupportedWallets } from '../../../domain/context/network/Wallet.js';
import ValidatedRequest from './validation/ValidatedRequest.js';
import Validation from './validation/Validation.js';
export { SupportedWallets };
export default class ConnectRequest extends ValidatedRequest {
    constructor({ account, network, mirrorNode, rpcNode, wallet, custodialWalletSettings, consensusNodes, }) {
        super({
            account: Validation.checkAccount(),
            wallet: Validation.checkString({ emptyCheck: true }),
        });
        this.account = account;
        this.network = network;
        this.mirrorNode = mirrorNode;
        this.rpcNode = rpcNode;
        this.wallet = wallet;
        this.custodialWalletSettings = custodialWalletSettings;
        this.consensusNodes = consensusNodes;
    }
}
__decorate([
    OptionalField(),
    __metadata("design:type", Object)
], ConnectRequest.prototype, "account", void 0);
